// import React, { forwardRef, useRef, useState, useImperativeHandle  } from "react";
// import ReactFlow, {
//   ReactFlowProvider,
//   useNodesState,
//   useEdgesState,
//   Controls
// } from "reactflow";
// import "reactflow/dist/style.css";
// import { generateFlowChart } from './generator';

// const Try = forwardRef(({ text, title }, ref) => {
//   const reactFlowWrapper = useRef(null);
//   const [reactFlowInstance, setReactFlowInstance] = useState(null);
  
//   const { nodes, edges } = generateFlowChart(text, title);
//   const [nodes1, setNodes] = useNodesState(nodes);
//   const [edges1, setEdges] = useEdgesState(edges);

//   useImperativeHandle(ref, () => ({
//     getChartElement: () => reactFlowWrapper.current
//   }));

//   return (
//     <div className="dndflow" ref={reactFlowWrapper}>
//       <ReactFlowProvider>
//         <div className="reactflow-wrapper" style={{ height: "500px", width: "100%" }}>
//           <ReactFlow
//             nodes={nodes1}
//             edges={edges1}
//             onInit={setReactFlowInstance}
//             proOptions={{ hideAttribution: true }}
//           >
//             <Controls />
//           </ReactFlow>
//         </div>
//       </ReactFlowProvider>
//     </div>
//   );
// });

// Try.displayName = "Try"; // Important for debugging

// export default Try;

import React, { forwardRef, useState, useRef, useCallback, useImperativeHandle } from "react";
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  applyNodeChanges,
  applyEdgeChanges,
  useNodesState,
  useEdgesState,
  Controls,
} from "reactflow";
import "reactflow/dist/style.css";
import { generateFlowChart } from './generator';
import "./style.css";

//import { initialNodes, initialEdges } from "./initialElements";
 // should export nodes & edges separately
import Sidebar from "./sidebar";

let id = 0;
const getId = () => `dndnode_${id++}`;

export default function Try({text, title}, ref) {
  const reactFlowWrapper = useRef(null);
  const chartContainerRef = useRef();
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  
  const { nodes, edges } = generateFlowChart(text, title);

  const [nodes1, setNodes, onNodesChange] = useNodesState(nodes);
  const [edges1, setEdges, onEdgesChange] = useEdgesState(edges);

  // useImperativeHandle(ref, () => ({
  //   getChartRef: () => chartContainerRef.current
  // }));

    useImperativeHandle(ref, () => ({
    getChartElement: () => reactFlowWrapper.current
  }));


  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    []
  );

  const onInit = (instance) => setReactFlowInstance(instance);

  const onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  };

  const onDrop = (event) => {
    event.preventDefault();
    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const type = event.dataTransfer.getData("application/reactflow");

    if (typeof type === "undefined" || !type) return;

    const position = reactFlowInstance.project({
      x: event.clientX - reactFlowBounds.left,
      y: event.clientY - reactFlowBounds.top,
    });

    const newNode = {
      id: getId(),
      type,
      position,
      data: { label: `${type} node` },
    };

    setNodes((nds) => nds.concat(newNode));
  };

  return (
    <div className="dndflow">
      <ReactFlowProvider>
        <div
          className="reactflow-wrapper"
          style={{ height: "500px", width: "500px" }}
          ref={reactFlowWrapper}
        >
          <ReactFlow
            nodes={nodes1}
            edges={edges1}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            onInit={onInit}
            onDrop={onDrop}
            onDragOver={onDragOver}
            proOptions={{ hideAttribution: true }}
            fitView={true}
          >
            <Controls />
          </ReactFlow>
        </div>
        {/* <Sidebar />  */}
      </ReactFlowProvider>
    </div>
  );
}
